import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

/**
 * ProtectedRoute — Guards routes that require authentication.
 * Redirects to login (/) if user is not authenticated.
 * Checks both Redux state and localStorage for auth persistence across refreshes.
 *
 * @param {React.ReactNode} children — The protected page component
 */
const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const { isAuthenticated } = useSelector((state) => state.auth);

  // Check both Redux state and localStorage (localStorage persists across refreshes)
  const hasToken = localStorage.getItem("mango_access_token");
  const isStoredAuth = localStorage.getItem("mango_authenticated") === "true";

  if (!isAuthenticated && !hasToken && !isStoredAuth) {
    // Save the attempted URL so we can redirect back after login
    return <Navigate to="/" state={{ from: location.pathname }} replace />;
  }

  return children;
};

export default ProtectedRoute;
